module.exports = __webpack_public_path__ + "img/Property.1168408b.svg";